import Vue from 'vue'
import Vuex from 'vuex'
import connectedCar from './modules/connectedCarInfo'
import ValidationView from './modules/ValidationView'
import DynamicData from './modules/DynamicData'
import MetaData from './modules/MetaData'
import DutyAgmtByModel from './modules/DutyAgmtByModel'
import Error from './modules/Error'
import loading from './modules/loading'
Vue.use(Vuex)

const actions = {
  saveStep1TnC(context, termConditionCheckedStatus) {
    context.commit(mutationType.step1.saveTnC, termConditionCheckedStatus)
  },
  saveApplicationNumber(context, applicationNumber) {
    context.commit(mutationType.saveApplicationNumber, applicationNumber)
  },
  saveOpenMarketInfo:function(context, openMarketInfo){
    context.commit(mutationType.saveOpenMarketInfo, openMarketInfo)
  },
  saveTpsInfo:function(context, tpsInfo){
    context.commit(mutationType.saveTpsInfo, tpsInfo)
  },
}

const mutations = {
  saveStep1TnC(state, termConditionCheckedStatus) {
    state.step1.termConditionCheckedStatus = termConditionCheckedStatus
  },
  saveApplicationNumber(state, applicationNumber) {
    state.applicationNumber = applicationNumber
  },
  saveOpenMarketInfo(state, openMarketInfo){
    state.openMarketInfo = openMarketInfo
  },
  saveTpsInfo(state, tpsInfo){
    state.appfData = tpsInfo
  },
}


const defaultStoreConfig = () => {
  const state = {
    //onsalehome (TPS)
    appfData:{
      prodCdCnt:'',
      csalesCd:'',
      selrId:'',
      selrTyp:'',
      tmpAplyTyp:'',
      selTyp:'',
      selPathCd:'',
      dlrCd:'',
      custNm:'',
      custNmY:'',
      custTyp:'',
      idenNo:'',
      idenNoY:'',
      idenNoY1:'',
      idenNoTyp:'',
      payType:'',
      bank:'',
      card:'',
      bankAccount:'',
      cardYY:'',
      cardMM:'',
      chargeSendType:'',
      telNo:'',
      ptTelNo:'',
      email:'',
      prodCd:'',
      spclDet:'',
      instlZipCd:'',
      instlAddrN:'',
      instlResidTyp:'',
      instlSdNm:'',
      instlSggNm:'',
      instlEmdNm:'',
      instlTownNm:'',
      instlRoadNm:'',
      instlBjdongNo:'',
      instlBldNm:'',
      instlLiNm:'',
      instlIslndNm:'',
      instlBldrpstNo:'',
      instlBldsubNo:'',
      instlBldrpstNoA:'',
      instlAptDong:'',
      instlAptHo:'',
      instlHsno:'',
      instlAddrHo:'',
      instlExtAddrSpec:'',
      instlLandcateTyp:'',
      instlHjdongNo:'',
      instlAddr:'',
      instlSchDvCd:'',
      instAddrResult:'',
      instlRoadNm1:'',
      instlRoadNm2:'',
      instlRoadNm3:'',
      sbcMthdTyp:'',
      certiMthdTyp:'',
      encryptIdenNo:'',
      certiOrganTyp:'',
      certiTm:'',
      certiRequestNo:'',
      certiResponseNo:'',
      certiSuccessYn:'',
      aplyrHpWapPsblYn:'',
      telecCoTyp:'',
      wapSndCorpNo:'',
      hpCertiYn:'',
      nmptYn:'',
      nmpt_befrChgCpNm:'',
      nmpt_befrChgCpTyp:'',
      nmpt_befrChgSctCpNm:'',
      nmpt_befrChgSctCpTyp:'',
      nmpt_custRelTyp:'',
      nmpt_instlCostRfndYn:'',
      nmpt_instlCostRfndAcntNo:'',
      nmpt_instlCostRfndBankNm:'',
      nmpt_aplyrNm:'',
      nmpt_aplyrIdenNo:'',
      nmpt_aplyrTelNo:'',
      nmpt_aplyrPtTelNo:'',
      nmpt_namerCertiMthdTyp:'',
      nmpt_namerCertiOrganTyp:'',
      nmpt_namerCertiRequestNo:'',
      nmpt_namerCertiResponseNo:'',
      nmpt_namerCertiSuccessYn:'',
      nmpt_namerCertiTm:'',
      nmpt_namerEncryptIdenNo:'',
      nmpt_namerIdenNo:'',
      nmpt_namerIdenNo1:'',
      nmpt_namerIdenNo2:'',
      nmpt_namerIdenNoTyp:'',
      nmpt_namerNm:'',
      nmpt_namerPtTelNo:'',
      nmpt_namerPtTelNo1:'',
      nmpt_namerPtTelNo2:'',
      nmpt_namerPtTelNo3:'',
      nmpt_namerTelNo:'',
      nmpt_namerTelNo1:'',
      nmpt_namerTelNo2:'',
      nmpt_namerTelNo3:'',
      nmpt_nmptNo:'',
      nmpt_nmptNo1:'',
      nmpt_nmptNo2:'',
      nmpt_nmptNo3:'',
      nmpt_reqInfoCheck:'',
      nmpt_billCntcInfoKdCd:'',
      nmpt_billCntcInfo1:'',
      appcTyp:'',
      bcortmpProd:'',
      bcortmpSvc:'',
      svcCustHopeYmd:'',
      tmpAplyStTyp:'',
      tmpAplyYmd:'',
      tmpAplyTs:'',
      custRegIp:'',
      rmk:'',
      AttrPath:'',
      custAgreeRegYn:'',
      extCallYn:'',
      workFlag:'',
      rtnurl:'',
      DupChkId:'',
      custInfoOfferCnsntYn:'',
      dpstrIdenNo:'',
      accdNo:'',
      accdNo1:'',
      homepageTest:'',
      mailTyp:'',
      custChk:'',
      sendconfirm:'',
      moct_birthDay:'',
      moct_name:'',
      moct_phoneNo:'',
      ipinCi:'',
      snglSppsRqstYn:'',
      custrnmBday:'',
      entrRsvRqstDvCd:'',
      line_cnt:'',
      chk_Y_0:'',
      chk_Y_1:'',
      chk_Y_2:'',
      chk_Y_4:'',
      posCd:'',
      macAddress:'',
      cnvgNo:'',
      sbcContNo:'',
      homeTPSActivationProductList:[],
      homeTPSActivationAgrList:[], //추가 - PrivacyCenter 통합관리시스템 구축 2차 온라인가입지원 프로젝트 
      dlrNm:'', // 장희정 추가
      isDomestic:'',
      autnIfSno:''  //TPS 모의해킹 정기점검 결과 조치 - 2025.08.05
    },
    //end onsalehome (TPS)

    // 오픈마켓 정보가 없을 시 dealer info를 표출 여부
    notFoundUrl: true,
    isConfirm: false,
    isMobile: false,

    // connected-car에도 사용
    processIndicator: {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
    },

    // Step1 제어
    step1: {
      termConditionCheckedStatus: {},
      // 고객 정보
      customer: {
        name: '',
        ssn1: '',
        ssn2: '',
        emailId:'',
        emailDomain:'',
        custKdCd: '',
        aplcErrno: '',
      },
      autnMthdDivsCd: '',
      onetAutnDivsCd: '',// 인증구분 추가 온세일 장희정 2023.09.14
      custInfoGthrAgrYn: 'N',
      pnifPuseTrstAgrYn: 'N',
      locFndnInfoOfrSvcAgrYn: 'N',
      mblAdRcpAgrYn: 'N',
      
      openMarketAgrInfo: [] //privacy 동의정보
           
    },

    // Step2 아코디언 제어
    step2Accordion: {
      isStep1: false,
      isStep2: false,
    },

    // 주소 동일 체크
    sameWithCustomerAddress: false,

    // KMC 정보
    kmcInfo: {
      phoneNo:'',
      name:'',
      birthDay:'',
      certNum:'',
    },

    // 오픈마켓 정보
    openMarketInfo: {
      formId:'',
      dealNm: '',
      agentId: '',
      agentName: '',
      agentAddress: '',
      agentTelNo: '',
      sellerName: '',
      sellerAddress: '',
      sellerTelNo: '',
      sellerRegistrationNo: '',
      sbgnPosCd: '',
      sbgnPosNm: '',
      openMarketCode: '', //오픈마켓번호
      openMarketName: '',
      msBsType: '', //기업부문 BS
      entrRqstFomNo: '', //양식ID
      dealCd: '', //대리점코드
      opmkEntrKdCd: '', //가입유형코드
      isttYn: '', //할부여부
      isttAmt: '', //할부금액
      registrationTypeCode: '', //가입유형
      registrationTypeName: '', //가입유형명
      rotrRqstCd: '',
      shndHphnYn: '', //중고여부
      rcmdSaleKcCd: '', //추천판매 agmtTermMmct discGb
      mblSvcDivsCd: '', //G106M2MLZP0002200모바일서비스구분코드
      dataPpMndtYn: '', //데이터요금제 필수여부
      dlrGroup: '',
      resCode: '',
      resMsg: '',
      onetDealOrgDivsCd: '',
      appfTitNm: '',
      appfDutyAgmtAmt: '',
      crgrSaleYn: '',
      rqstCustDelKdCd: '',
      rqstOrdrNoTitNm: '',
      rqstTmpDutyAgmtAmt: '',
      onetRcmdSaleCd: '',
      appfUseStrtDttm: '',
      appfUseEndDttm: '',
      ppfUseYn: '',
      rqstBdlProdCd: '',
      rsvSaleNm: '',
      dcntKdNm: '',
      chocAgmtMmct: '',
      addSuptAmtUseYn: '',
      rotrRqstYn: '',
      svcDivsCd: '',
      rsvSaleYn: '',
      miltaryAgentYn: '',
      emalAddr: '',
      faxNo: '',
      chocAgmtDcntUseYn: '',   // 할인유형명
      onetTxinsrUseYn: '',     // 내 맘대로 폰교체 노출yn
      onetAplePncrDivsCd: ''   // 맘대로 폰교체
      //[ST]신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙
      ,onetDsnySppsAgrYn:''
      //[ED]신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙
      //[단통법폐지Prj] Start 단통법 폐지관련 추가 2025.06.04 miyoung34
      ,lrpsDiscOpenYn:'N'     //단통법폐지 프로젝트 오픈여부
      ,presaleTrmMdlCdYn:'N'  //단통법폐지 프로젝트 오픈 전 사전판매모델여부
      ,dmbrYn:'N'             //직영점여부
      ,presaleTrmMdlCdTxt:''  //단통법폐지 프로젝트 오픈 전 사전판매모델문자열(, 구분자)
      //[단통법폐지Prj] Start 단통법 폐지관련 추가 2025.06.04 miyoung34
    },
    samsung:{
      trmMdlCd:'', //단말모델코드
      trmMdlNm:'', //단말모델명
      esimTrmYn:'',//esim단말여부
      ppCd:'', //요금제코드
      ppNm:'', //요금제명
      usimYn:'', //유심신청여부 
      dcntKdCd:'', //할인유형코드 
    },

    // 신청서 번호
    applicationNumber: '',
  }

  return {
    state: state,
    actions: actions,
    mutations: mutations,
    modules: {
      connectedCar,
      ValidationView,
      DynamicData,
      MetaData,
      DutyAgmtByModel,
      Error,
      loading
    },
  }
}

const store = new Vuex.Store(defaultStoreConfig())

const actionType = {
  saveStep1TnC: 'saveStep1TnC',
  saveApplicationNumber: 'saveApplicationNumber',
  saveOpenMarketInfo:'saveOpenMarketInfo',
  saveTpsInfo:'saveTpsInfo',
}

const mutationType = {
  step1: {
    saveTnC: 'saveStep1TnC',
  },
  saveApplicationNumber: 'saveApplicationNumber',
  saveOpenMarketInfo:'saveOpenMarketInfo',
  saveTpsInfo:'saveTpsInfo',
}

export {store, defaultStoreConfig, actionType}

